import { useState, useEffect, useCallback } from "react";
import styles from "./Loader.module.css";

const LMLogo = () => (
  <div className={styles.logoWrap}>
    <svg viewBox="0 0 200 190" className={styles.logoSvg} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#C4A882" />
          <stop offset="50%" stopColor="#D5C4AE" />
          <stop offset="100%" stopColor="#C4A882" />
        </linearGradient>
      </defs>
      {/* L letter */}
      <path
        className={styles.drawPath}
        d="M 40 20 L 40 140 L 80 140"
        fill="none"
        stroke="url(#goldGrad)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* M letter */}
      <path
        className={styles.drawPath}
        style={{ animationDelay: "0.6s" }}
        d="M 60 140 L 60 30 L 100 100 L 140 30 L 140 140"
        fill="none"
        stroke="url(#goldGrad)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Serif details */}
      <path
        className={styles.drawPath}
        style={{ animationDelay: "1.2s" }}
        d="M 30 20 L 50 20 M 30 140 L 55 140 M 50 30 L 70 30 M 130 30 L 150 30 M 50 140 L 70 140 M 130 140 L 150 140"
        fill="none"
        stroke="url(#goldGrad)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {/* Lilach Morad text */}
      <text
        className={styles.drawText}
        x="100"
        y="175"
        textAnchor="middle"
        fill="#C4A882"
        fontFamily="BrutalistLight, sans-serif"
        fontSize="18"
        letterSpacing="4"
      >
        Lilach Morad
      </text>
    </svg>
    <div className={styles.hebrewSubtitle} dir="rtl">תכנון ועיצוב פנים</div>
  </div>
);

const Loader = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 30);
    return () => clearInterval(interval);
  }, []);

  const handleComplete = useCallback(() => {
    if (onComplete) onComplete();
  }, [onComplete]);

  useEffect(() => {
    if (progress === 100) {
      const timer = setTimeout(() => setFadeOut(true), 400);
      const done = setTimeout(handleComplete, 1200);
      return () => { clearTimeout(timer); clearTimeout(done); };
    }
  }, [progress, handleComplete]);

  return (
    <div className={`${styles.loader} ${fadeOut ? styles.fadeOut : ""}`}>
      <div className={styles.content}>
        <LMLogo />
        <div className={styles.progressWrap}>
          <div className={styles.progressBar}>
            <div className={styles.progressFill} style={{ width: `${progress}%` }} />
          </div>
          <span className={styles.progressText}>{progress}%</span>
        </div>
        <p className={styles.loadingText}>טוען את החוויה</p>
      </div>
    </div>
  );
};

export default Loader;
